<template>
    <div class="main-layout">
        <navbar/>

        <div class="main-container container mt-4">
            <child/>
        </div>
    </div>
</template>

<script>
import Navbar from '~/components/Navbar'

export default {
    name: 'MainLayout',

    components: {
        Navbar
    }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/layouts/default.vue